import { Button } from '@/components/Button'
import { ButtonLink } from '@/components/ButtonLink'
import { YANDEX_METRIKA, YANDEX_METRIKA_COUNTER } from '@/config'
import { Icon } from '@/icons'
import { orderCallPopupStore } from '@/store/OrderCallPopup.store'
import cn from 'classnames'
import { FC, useCallback } from 'react'
import styles from './NavigationContacts.module.scss'

interface NavigationContactsProps {
  className?: string
  telegram: string
  whatsapp: string
  max: string
}
export const NavigationContacts: FC<NavigationContactsProps> = ({
  className,
  telegram,
  whatsapp,
  max,
}) => {
  const orderCallClick = useCallback(() => {
    if (YANDEX_METRIKA) {
      // @ts-ignore
      ym(YANDEX_METRIKA_COUNTER, 'reachGoal', 'BUTTON_ORDER_CALL_CLICK')
    }
    orderCallPopupStore.show()
  }, [])

  return (
    <div className={cn(styles.container, className)}>
      <a href="tel:88002220403" className={styles.phone}>
        8 (800) 222-04-03
      </a>
      <div className={styles.buttons}>
        <Button
          className={styles.callBtn}
          variant={'opacity'}
          type="button"
          onClick={orderCallClick}
        >
          Обратный звонок
        </Button>
        <ButtonLink
          href={telegram}
          target="_blank"
          variant="opacity"
          className={styles.socButton}
        >
          <Icon name="telegram" className={styles.socIcon} />
          <span className={styles.socText}>Мы в Telegram</span>
        </ButtonLink>
        <ButtonLink
          href={whatsapp}
          target="_blank"
          variant="opacity"
          className={styles.socButton}
        >
          <Icon name="whatsapp" className={styles.socIcon} />
          <span className={styles.socText}>Мы в WhatsApp</span>
        </ButtonLink>
        <ButtonLink
          href={max}
          target="_blank"
          variant="opacity"
          className={styles.socButton}
        >
          <Icon name="max" className={styles.socIcon} />
          <span className={styles.socText}>Мы в MAX</span>
        </ButtonLink>
      </div>
    </div>
  )
}
